import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.piniaStore.state.isMakler)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Dieses Risiko ist nicht versicherbar."))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, "Aufgrund Ihrer Angabe können wir Ihnen leider keinen Versicherungsschutz anbieten."))
}